<template>
<div class="page">
  <!-- 新手指南 -->
  <div class="new_user_box">
    <div class="title">新手指南</div>
    <div class="list_box" v-for="(item,index) in newUserList" :key="index" @click="openQuestion(item)">
      <div class="question_row">
        <span class="left">{{item.questionTitle}}</span>
        <span :class=" item.isOpen ? 'arrow_up' : '' " class="arrow"></span>
      </div>
      <div v-if="item.isOpen" class="answer_box">{{item.questionContent}}</div>
    </div>
  </div>
  <!-- 问题 -->
  <div class="question_box mt20">
    <div class="title">常见问题</div>
    <div class="list_box" v-for="(item1,index1) in questionList" :key="index1" @click="openQuestion(item1)">
      <div class="question_row">
        <span class="left">{{item1.questionTitle}}</span>
        <span :class=" item1.isOpen ? 'arrow_up' : '' " class="arrow"></span>
      </div>
      <div v-if="item1.isOpen" class="answer_box">{{item1.questionContent}}</div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      newUserList:[],             //新手指南
      questionList:[],            //常见问题
    }
  },
  components: {
  },
  created () {
    // 获取问题列表
    this.getQuestionList();
  },
  mounted () {
  },
  computed:{
  },
  methods: {
    // 获取问题列表
    getQuestionList(){
      this.$http.get('/survey/help/getQuestionInfoList').then(res=>{
        console.log(res);
        if(res.code == 200){
          res.data.newUser.forEach(item=>{
            item.isOpen = false;
          });
          res.data.questions.forEach(item=>{
            item.isOpen = false;
          });
          this.newUserList = res.data.newUser;
          this.questionList = res.data.questions;
          console.log(this.newUserList,this.questionList);
        }
      });
    },
    // 展开问题
    openQuestion(item){
      item.isOpen = !item.isOpen;
    },
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  min-height: 100vh;
  background-color: #F0F2F8;
  padding: 20px 24px;
  box-sizing: border-box;
  
  .new_user_box,.question_box{
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 32px 20px;
    box-sizing: border-box;
    .title{
      font-size: 32px;
      font-weight: bold;
      line-height: 45px;
    }
    .list_box{
      margin-top: 28px;
      width: 100%;
      background-color: #fff;
      .question_row{
        width: 100%;
        display: flex;
        justify-content: space-between;
        transition: 1s ease all;
        .left{
          font-size: 28px;
          line-height: 42px;
          color: #666666;
        }
        .arrow{
          margin-top: 15px;
          margin-left: 36px;
          width: 19px;
          height: 10px;
          background: url('../../assets/images/other/arrow_bottom.png') no-repeat;
          background-size: contain;
          &.arrow_up{
            transform: rotate(180deg);
          }
        }
      }
      .answer_box{
        padding: 24px 20px 20px;
        box-sizing: border-box;
        margin-top: 12px;
        font-size: 28px;
        line-height: 42px;
        color: #999999;
        background-color: #F6F7FB;
        border-radius: 8px;
      }
    }
  }
  .mt20{
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/other/help.vue